module.exports = __WEBPACK_EXTERNAL_MODULE_71__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 71
// module chunks = 0